module.exports = __webpack_public_path__ + "static/media/corporate-subscribe-banner.e1942862.png";